export enum WorkorderInvoiceType {
  Standard = 'standard',
  Warranty = 'warranty',
  Internal = 'internal'
}
